import { css } from '@emotion/react';
import sctheme from 'app/styles/sctheme';

const styles = (sctheme: any) => css`
  .wrapper {
    display: flex;
    flex-direction: column;
    margin-right: auto;
    margin-left: auto;
    height: 100%;
    @media (max-width: 720px) {
      height: 100vh;
    }
    @media (min-width: 721px) {
      overflow: hidden;
    }
  }

  .layout {
    @media (max-width: 720px) {
      position: relative;
      top: 62px;

      &.extra-padding-mobile {
        padding-top: 1.75rem;
      }
    }
    @media (min-width: 721px) {
      display: flex;
    }
    align-items: stretch;
    height: calc(100vh - 62px);
  }

  .system-message {
    background-color: ${sctheme.blues.secondary};
    color: ${sctheme.white};
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid ${sctheme.white};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    &.mobile {
      display: none;
    }

    @media (max-width: 1200px) {
      display: none;

      &.mobile {
        display: flex;
        flex-direction: row;
        text-align: left;
        width: 100vw;
        min-height: 2rem;
      }
    }
  }
`;

export default styles(sctheme);
